import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageSection, Row, Cell, Button, Divider } from 'sarsaparilla';
import { showLoginModal } from '../actions/index';

const propTypes = {
  message: PropTypes.string.isRequired,
  showLoginModal: PropTypes.func.isRequired
};

export class LoginRequest extends PureComponent {
  render() {
    const { message, showLoginModal: showLogin } = this.props;

    return (
      <PageSection>
        <Row>
          <Cell>
            <h2>Order Details</h2>
            <Divider />
            <p>
              {message}
            </p>
            <Button onClick={showLogin}>
              Sign Up / Log In
            </Button>
          </Cell>
        </Row>
      </PageSection>
    );
  }
}

LoginRequest.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  showLoginModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoginRequest);
